import React, { useState, memo, useEffect, useRef } from 'react'
import { Button, Box, TextInput, Select as SelectG } from 'grommet'
import { useDispatch, useSelector } from 'react-redux'
import { Close } from 'grommet-icons'
import styled from 'styled-components'
import Icon from '../ReactRTG/IconInput'
import {
  itemCloseClicked,
  itemGenderChanged,
  itemInputChanged,
  itemLabelChanged,
  itemToggleChanged,
} from '../../redux/rtg/actions'
import { CheckBox } from '../Common'
// import { useDarkMode } from '../../contextHook/darkMode'

const Container = styled(Box)`
  flex-shrink: 0;
  padding-right: 9px;
`

const MainInput = styled(TextInput)`
  background-color: ${props => props.theme.global.colors.secondaryBg};
  border: none;
  border-radius: 0px;
  padding: 0.3rem 0.5rem;
`

// const SecondInput = styled(TextInput)`
//   background-color: ${props => props.theme.global.colors.accent};
//   border: none;
//   border-radius: 0px;
//   /* padding: 0.5rem; */
// `

const CloseButton = styled(Button)`
  padding: 0 0 0 0.3rem;
`

const Select = styled(SelectG)`
  padding: 0rem;
  max-width: 3rem;
  text-align: center;
`

const SelectBox = styled(Box)`
  /* & > button {
    height: 2.8rem;
  } */
`

const ListItem = ({
  name,
  gender,
  label = 'A',
  index,
  style,
  inputFocus,
  hideGenderLabel,
  filtered = false,
}) => {
  // const toolColors = useSelector(state => state.settings.wheelColors.colors)
  const [inputValue, setInputValue] = useState(name)
  const evenSplit = useSelector(state => state.rtg.evenSplit)
  const [initDone, setInitDone] = useState(false)
  // const { value: darkMode } = useDarkMode()

  const dispatch = useDispatch()
  //   // const filteredChoices = useSelector(state => state.main.filteredChoices)

  const inputRef = useRef(null)

  useEffect(() => {
    if (inputFocus.focus === index && inputRef.current) {
      // Move element into view when it is focused
      if (initDone) {
        // do sinputFocus.omething
        inputRef.current.focus()
      }
    }
  }, [inputFocus.focus === index])

  useEffect(() => {
    if (!initDone) {
      setInitDone(true)
    } else {
      const timeOutId = setTimeout(
        () => dispatch(itemInputChanged(inputValue, index)),
        200,
      )
      return () => clearTimeout(timeOutId)
    }
  }, [inputValue])

  const inputChanged = event => {
    event.preventDefault()
    const newValue = event.target.value
    // let newChoices = choices.slice(0)
    // newChoices[index].name = newValue
    setInputValue(newValue)
    // dispatch(setChoices(newChoices.slice(0)))
  }

  // const inputChanged = (event, id) => {
  //   event.preventDefault()
  //   const newValue = event.target.value
  //   let newPeople = people.slice(0)
  //   newPeople[id].name = newValue
  //   setInputValue(newValue)
  //   dispatch(setPeople(newPeople.slice(0)))
  // }

  // const genderChanged = (gender, id) => {
  //   let newPeople = people.slice(0)
  //   newPeople[id].gender = gender
  //   setGender(gender)
  //   dispatch(setPeople(newPeople.slice(0)))
  // }

  // const closeClicked = id => {
  //   let array = people.slice(0)
  //   array.splice(id, 1)
  //   // let newFilteredChoices = filteredChoices.slice(0)
  //   // newFilteredChoices = newFilteredChoices.filter(e => e !== id)
  //   // for (var i = 0; i < newFilteredChoices.length; i++) {
  //   //   if (newFilteredChoices[i] > id) {
  //   //     newFilteredChoices[i] = newFilteredChoices[i] - 1
  //   //   }
  //   // }
  //   dispatch(setPeople(array.slice(0)))
  //   dispatch(changeKeyTextRTG())

  //   // dispatch(setFilteredChoices(newFilteredChoices.slice(0)))
  // }

  return (
    <Container
      direction="row"
      // gap=".3rem"
      align="stretch"
      style={{
        ...style,
        height: style.height - 6,
      }}
    >
      <Box direction="row" flex={true} align="center" pad="0px" gap=".3rem">
        {/* <Box direction="row" align="center" pad="0px"> */}
        {/* <Box width="2.5rem" align="end">
          <Text size="1.5rem">{`${index + 1}.`}</Text>
        </Box> */}

        <MainInput
          type="text"
          enterKeyHint="done"
          ref={inputRef}
          value={inputValue}
          onChange={event => {
            inputChanged(event)
          }}
          onClick={() => inputFocus.handleClick(index)}
          onKeyDown={inputFocus.handleKeyDown}
        ></MainInput>
        {/* </Box> */}
      </Box>

      {!hideGenderLabel && evenSplit === 'Gender' && (
        <Box direction="row" align="center" gap=".3rem" pad="0 .3rem">
          <Icon
            size="2.4rem"
            name="UnisexIcon"
            active={gender === 'unisex' ? true : false}
            clicked={() => {
              dispatch(itemGenderChanged('unisex', index))
            }}
          />
          <Icon
            size="2.4rem"
            name="MaleIcon"
            active={gender === 'male' ? true : false}
            clicked={() => {
              dispatch(itemGenderChanged('male', index))
            }}
          />
          <Icon
            size="2.4rem"
            name="FemaleIcon"
            active={gender === 'female' ? true : false}
            clicked={() => {
              dispatch(itemGenderChanged('female', index))
            }}
          />
        </Box>
      )}
      {!hideGenderLabel && evenSplit === 'Label' && (
        <SelectBox pad="0 .3rem" alignSelf="center">
          <Select
            options={['A', 'B', 'C', 'D', 'E', 'F', 'G']}
            value={label}
            onChange={({ option }) => dispatch(itemLabelChanged(option, index))}
            tabIndex="-1"
          />
        </SelectBox>
      )}
      <CheckBox
        tabIndex="-1"
        pad="0 .3rem"
        checked={filtered === undefined ? true : !filtered}
        alignSelf="center"
        onChange={event => {
          const status = event.target.checked
          // setChecked(status)
          // setTimeout(() => {
          dispatch(itemToggleChanged(status, index))
          // }, 50)
        }}
        // size={size}
        // activeColor={
        //   !darkMode || toolColors.length < 3 ? toolColors[0] : toolColors[2]
        // }
        size="22px"
      />
      <CloseButton
        icon={<Close color="reject" size="22px" />}
        alignSelf="center"
        // onClick={() => {}}
        onClick={() => dispatch(itemCloseClicked(index))}
        tabIndex="-1"
      />
    </Container>
  )
}

export default memo(ListItem)
